import React from 'react';
import { EffectComposer, Bloom, Vignette } from '@react-three/postprocessing';

export default function PostEffects() {
  return (
    <EffectComposer multisampling={0}>
      {/* Calm, steady bloom with high threshold so particles don't flash */}
      <Bloom
        luminanceThreshold={1.8}
        luminanceSmoothing={0.3}
        intensity={0.7}
        mipmapBlur
      />
      <Vignette offset={0.25} darkness={0.65} />
    </EffectComposer>
  );
}
